import React, { Component } from "react";
import { connect } from "react-redux";

import ProjectQaWeldingInspectionForm from "./form";
import { createProjectQaWeldingInspection } from "../actions";

import { Page, Navbar } from "framework7-react";

// Persisted Stuff
import Form from "modules/4_final_form/PersistedForm";
import { clearPersisted } from "modules/4_final_form/PersistDecorator";
import { persistedName } from "./vairables.js";

// Helpers
import HasRole from "modules/5_view_helpers/HasRole";
import arrayMutators from "final-form-arrays";
import NotAuthorized from "modules/5_view_helpers/mobile/NotAuthorized";

function mapStateToProps(state) {
  return {
    project_qa_welding_inspections_welding_procedures: _.orderBy(state.project_qa_welding_inspections_welding_procedures, "name"),
    project_qa_welding_inspections_welding_types: _.orderBy(state.project_qa_welding_inspections_welding_types, "name"),
    project_qa_welding_inspections_welding_processes: _.orderBy(state.project_qa_welding_inspections_welding_processes, "name"),
    project_qa_welding_inspections_welding_stages: _.orderBy(state.project_qa_welding_inspections_welding_stages, "name"),
    project_qa_welding_inspections_welding_standards: _.orderBy(state.project_qa_welding_inspections_welding_standards, "name"),
    project_qa_welding_inspections_fillet_sizes: _.orderBy(state.project_qa_welding_inspections_fillet_sizes, "name"),
    project_qa_welding_inspections_access_restrictions: _.orderBy(state.project_qa_welding_inspections_access_restrictions, "name"),
    project_qa_welding_inspections_viewing_conditions: _.orderBy(state.project_qa_welding_inspections_viewing_conditions, "name"),
    project_qa_welding_inspections_surface_conditions: _.orderBy(state.project_qa_welding_inspections_surface_conditions, "name"),
  };
}

class NewProjectQaWeldingInspections extends Component {
  constructor(props) {
    super(props);
    this.submitForm = this.submitForm.bind(this);
    this.successfullySubmitted = this.successfullySubmitted.bind(this);

    const createRole = HasRole(
      {
        resource_type: "Project::Qa::WeldingInspection",
        name: ["create", "moderator"],
      },
      true
    );

    const returnUrl = `/project/qa/welding_inspections`;

    this.state = {
      returnUrl: returnUrl,
      createRole,
    };
  }

  submitForm(values) {
    const {
      f7router: { app },
      project_id,
    } = this.props;

    // When clicked okay
    this.preloader = app.preloader;
    this.preloader.show();
    const createRequest = this.props.createProjectQaWeldingInspection(project_id, values, false);
    createRequest.then(this.successfullySubmitted);
  }

  successfullySubmitted() {
    const {
      f7router,
      f7router: { app },
    } = this.props;

    const { returnUrl } = this.state;

    this.preloader.hide();
    clearPersisted(persistedName).then(() => {
      app.toast
        .create({
          icon: '<i class="material-icons">check</i>',
          text: "Created Welding Inspection!",
          position: "center",
          closeTimeout: 2000,
          on: {
            opened: () => {
              f7router.navigate(returnUrl);
            },
          },
        })
        .open();
    });
  }

  render() {
    const {
      history,
      project_qa_welding_inspections_welding_standards,
      project_qa_welding_inspections_welding_types,
      project_qa_welding_inspections_surface_conditions,
      project_qa_welding_inspections_viewing_conditions,
      project_qa_welding_inspections_access_restrictions,
    } = this.props;
    const { returnUrl, createRole } = this.state;

    const default_welding_standard = _.find(project_qa_welding_inspections_welding_standards, (ar) => ar.default);
    const default_welding_type = _.find(project_qa_welding_inspections_welding_types, (ar) => ar.default);

    const default_surface_condition = _.find(project_qa_welding_inspections_surface_conditions, (ar) => ar.default);
    const default_viewing_condition = _.find(project_qa_welding_inspections_viewing_conditions, (ar) => ar.default);
    const default_access_restriction = _.find(project_qa_welding_inspections_access_restrictions, (ar) => ar.default);

    if (!createRole) {
      return <NotAuthorized />;
    }

    return (
      <Page>
        <Navbar title="New Welding Inspection" backLink />
        <Form
          persist={{ name: persistedName }}
          component={ProjectQaWeldingInspectionForm}
          onSubmit={this.submitForm}
          mutators={{
            ...arrayMutators,
          }}
          initialValues={{
            date: moment().format("YYYY-MM-DD"),
            welding_standard_id: default_welding_standard?.id,
            welding_type_id: default_welding_type?.id,
            surface_condition_id: default_surface_condition?.id,
            viewing_condition_id: default_viewing_condition?.id,
            access_restriction_id: default_access_restriction?.id,
          }}
          formLabel="Create"
          cancelFunction={() => {
            history.push(returnUrl);
          }}
          {...this.props}
        />
      </Page>
    );
  }
}

export default connect(mapStateToProps, { createProjectQaWeldingInspection })(NewProjectQaWeldingInspections);
